import {SettingsComponent} from './settings.component';

export default SettingsComponent;